import { Industry } from "../Industry.model";

export class Company {
    _id: String;
    name: String;
    cnpj: String;
    active: Boolean;
    purchaseRecurring: Boolean;
    sapCardCode: String;
    industry: Industry

    constructor(company?) {
        if (company)
            this.populate(company)
    }

    private populate(company) {
        this._id = company._id;
        this.name = company.name;
        this.cnpj = company.cnpj;
        this.active = company.active?company.active:false;
        this.purchaseRecurring = company.purchaseRecurring;
        this.sapCardCode = company.sapCardCode;
        this.industry = company.industry
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Company.model.ts